export class GetPrecosProdutosAutomaticosRequest {
    listIdsProdutos: number[];
    idAcaoAjustePreco: number;
    idUnidadeAjustePreco: number;
    idTipoArredondamento: number;
    valorAjuste: number;
}


